import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SingleEncoder from './SingleEncoder';
import App from './App';

import 'primereact/resources/themes/mdc-dark-deeppurple/theme.css';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';


import { PrimeReactProvider } from 'primereact/api';


// ------ SINGLE ENCODER ------
// const rootElement = document.getElementById('root');
// if (rootElement) {
//   const toolCode = rootElement.getAttribute('data-tool') || ''; // Provide a default value if necessary

//   const root = ReactDOM.createRoot(rootElement);
//   root.render(
//     <React.StrictMode>
//       <PrimeReactProvider>
//         <SingleEncoder toolCode={toolCode} />
//       </PrimeReactProvider>
//     </React.StrictMode>
//   );
// }

// ------ COMPRESION PLAYGROUND ------
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>
);